import { OrderManagementPermissions } from "@redotech/account-common/permissions";
import {
  createLazyContext,
  useLazyContextProvider,
  useRequiredContext,
} from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { RedoFulfillmentLocation } from "@redotech/redo-model/fulfillments/fulfillment-location";
import { memo, ReactNode } from "react";

export const LocationContext =
  createLazyContext<readonly RedoFulfillmentLocation[]>();
export const LocationService = memo(function LocationService({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const client = useRequiredContext(RedoMerchantRpcClientContext);

  const canViewLocations = useHasPermission(
    OrderManagementPermissions.SCAN_AND_VERIFY,
  );

  const loadState = useLazyContextProvider(async (signal) => {
    if (!canViewLocations) {
      return [];
    }
    const { locations } = await client.getLocations(null, { signal });
    return locations;
  });

  return (
    <LocationContext.internalContext.Provider value={loadState}>
      {children}
    </LocationContext.internalContext.Provider>
  );
});
